// extracted by mini-css-extract-plugin
module.exports = {"main":"Notifications_main__3yP8e","box":"Notifications_box__B0sS7"};